import {BASE_ELEMENT_IDS} from "../BaseDOM";
import {ELEMENT_IDS} from "../mobile/MobileDOM";

export default class AjaxLoading {

    private hided: boolean = false;

    private bg: HTMLElement;

    private colorArray: any[];

    private changeColorInterval: number;
    private hideTimeout: number;
    private changeColorDuration: number = 6000;

    constructor() {

        this.colorArray = ["white", "#00BFFF", "gold", "#DC143C"];
    }

    create(parent: HTMLElement) {

        let bg = document.createElement("div");
        bg.classList.add("mx-ajax-loading-bg");
        this.bg = bg;

        $(bg).append(`
            <div id="${BASE_ELEMENT_IDS.AJAX_LOADING_CONTAINER}">
                <div class="ldio-nriagv6fcmi">
                    <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
                </div>
                <div class="mx-ajax-loading-text mx-translate" data-lang="waiting_for_server_response">Waiting for server response...</div>
            </div>
        `);

        parent.appendChild(bg);

        this.hideLoading(0);
    }

    showLoading() {

        if(!this.hided) return;
        this.hided = false;

        document.getElementById("mxAjaxLoadingContainer")?.classList?.add("loadingio-spinner-spin-pmj0p6bsq8");

        $(this.bg).show();
        $(this.bg).css({opacity: 1});

        clearInterval(this.changeColorInterval);
        clearTimeout(this.hideTimeout);

        this.changeColor(0);

        let i = 1;
        this.changeColorInterval = setInterval(() => {
            this.changeColor(i % (this.colorArray.length));
            i++;
        }, this.changeColorDuration);

    }

    private changeColor(index) {
        $(".ldio-nriagv6fcmi div > div").css({"transition": `background-color ${this.changeColorDuration}ms`,  "background-color": this.colorArray[index]});
    }

    hideLoading(duration = 310) {

        if(this.hided) return;
        this.hided = true;

        clearTimeout(this.hideTimeout);

        $(this.bg).css({opacity: 0});
        this.hideTimeout = setTimeout(() => {


            clearInterval(this.changeColorInterval);

            $(this.bg).hide();
            document.getElementById("mxAjaxLoadingContainer")?.classList?.remove("loadingio-spinner-spin-pmj0p6bsq8");

        }, duration);
    }

    destroy() {
        if (document.getElementById(BASE_ELEMENT_IDS.AJAX_LOADING_CONTAINER))
            this.bg.removeChild(document.getElementById(BASE_ELEMENT_IDS.AJAX_LOADING_CONTAINER));
    }
}